import {createEvent} from "effector";

export const changeActiveFilterEv = createEvent()

export const resetActiveFiltersEv = createEvent()
